import React from "react"
import PlaylistListItemShort from "../posts/PlaylistListItemShort"
import { FeedSpinner } from "../shared/Spinner"
import { RequestError } from "../shared/RequestError"
import {
  useBandCreatedPlaylists,
  useBandFeaturedPlaylists,
} from "../../hooks/useBandPlaylists"

interface BandPlaylistsSectionProps {
  bandId: number | string
  bandName: string
}

const BandPlaylistsSection: React.FC<BandPlaylistsSectionProps> = ({ bandId, bandName }) => {
  const { data: createdData, status: createdStatus, error: createdError } = useBandCreatedPlaylists(bandId)
  const { data: featuredData, status: featuredStatus, error: featuredError } = useBandFeaturedPlaylists(bandId)

  const created: any[] = (createdData as any)?.playlists || []
  const allFeatured: any[] = (featuredData as any)?.playlists || []

  const createdIds = new Set(created.map((p) => p.id))
  const featured = allFeatured.filter((p) => !createdIds.has(p.id))

  const isLoading = createdStatus === "loading" || featuredStatus === "loading"
  const isError = createdStatus === "error" || featuredStatus === "error"

  if (isLoading) return <FeedSpinner />
  if (isError) return <RequestError error={createdError || featuredError} />

  if (created.length === 0 && featured.length === 0) {
    return (
      <p className="text-sm text-gray-400">
        {bandName} doesn't have any playlists yet.
      </p>
    )
  }

  return (
    <div className="space-y-8">
      {created.length > 0 && (
        <section>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">
            Created by {bandName}
          </h3>
          <ul>
            {created.map((playlist) => (
              <PlaylistListItemShort key={playlist.id} playlist={playlist} />
            ))}
          </ul>
        </section>
      )}
      {featured.length > 0 && (
        <section>
          <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">
            Featured on
          </h3>
          <ul>
            {featured.map((playlist) => (
              <PlaylistListItemShort key={playlist.id} playlist={playlist} />
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}

export default BandPlaylistsSection
